export const ADD_CALENDAR_DATA = 'ADD_CALENDAR_DATA'
export const ADD_INBOX_DATA = 'ADD_INBOX_DATA'
export const UPDATE_INBOX_DATA_FETCH_INPROGRESS = 'UPDATE_INBOX_DATA_FETCH_INPROGRESS'
export const ADD_CASE_DETAILS = 'ADD_CASE_DETAILS'
export const ADD_PROFILE_DATA = 'ADD_PROFILE_DATA'
export const GET_USERS_DATA = 'GET_USERS_DATA'
export const UPDATE_FETCH_USERS_DATA_INPROGRESS = 'UPDATE_FETCH_USERS_DATA_INPROGRESS'
export const GET_USER_PROFILE_DATA = 'GET_USER_PROFILE_DATA'
export const GET_USERS_BY_GROUP_ID = 'GET_USERS_BY_GROUP_ID'
export const EDIT_PROFILE_DATA = 'EDIT_PROFILE_DATA'
export const DELETE_USER_DATA = 'DELETE_USER_DATA'
export const USER_LOGIN_DATA = 'USER_LOGIN_DATA'
export const USER_LOGIN_ERROR = 'USER_LOGIN_ERROR'
export const SET_APP_CONFIGURATIONS = 'SET_APP_CONFIGURATIONS'
export const SET_AWS_CREDENTIALS = 'SET_AWS_CREDENTIALS'
export const USER_LOGOUT = 'USER_LOGOUT'
export const ADD_AVAILABILITY_DATA = 'ADD_AVAILABILITY_DATA'
export const ADD_HOLIDAY_DATA = 'ADD_HOLIDAY_DATA'
export const UPDATE_HOLIDAY_DATA_INPROGRESS = 'UPDATE_HOLIDAY_DATA_INPROGRESS'
export const UPDATE_CASEHISTORY_FETCH_INPROGRESS = 'UPDATE_CASEHISTORY_FETCH_INPROGRESS'
export const GET_CASE_HISTORY_DATA = 'GET_CASE_HISTORY_DATA'
export const GET_USERS_LIST_BY_GROUP_ID = 'GET_USERS_LIST_BY_GROUP_ID'
export const ADD_READY_FOR_PICKUP = 'ADD_READY_FOR_PICKUP'
export const UPDATE_READY_FOR_PICKUP_FETCH_INPROGRESS = 'UPDATE_READY_FOR_PICKUP_FETCH_INPROGRESS'
export const ADD_DISPATCH_DATA = 'ADD_DISPATCH_DATA'
export const UPDATE_DISPATCH_DATA_FETCH_INPROGRESS = 'UPDATE_DISPATCH_DATA_FETCH_INPROGRESS'
export const ADD_IN_PROGRESS_DATA = 'ADD_IN_PROGRESS_DATA'
export const UPDATE_FETCH_PROGRESS_DATA_INPROGRESS = 'UPDATE_FETCH_PROGRESS_DATA_INPROGRESS'
export const ADD_COMPLETE_DATA = 'ADD_COMPLETE_DATA'
export const UPDATE_FETCH_COMPLETE_DATA_INPROGRESS = 'UPDATE_FETCH_COMPLETE_DATA_INPROGRESS'
export const RECEIVE_PATHOLOGISTS_SLIDES_DATA = 'RECEIVE_PATHOLOGISTS_SLIDES_DATA'
export const RECEIVE_PATHOLOGISTS_SLIDES_DATA_ERROR = 'RECEIVE_PATHOLOGISTS_SLIDES_DATA_ERROR'
export const COMPLETE_CASE_DATA = 'COMPLETE_CASE_DATA'
export const COMPLETE_CASE_DATA_ERROR = 'COMPLETE_CASE_DATA_ERROR'
export const LAUNCH_PREMERIS_DATA = 'COMPLETE_CASE_DATA'
export const LAUNCH_PREMERIS_DATA_ERROR = 'COMPLETE_CASE_DATA_ERROR'
export const ADD_PATHOLOGIST_PENDING_DATA = 'ADD_PATHOLOGIST_PENDING_DATA'
export const UPDATE_FETCH_PATHOLOGIST_PENDING_DATA_INPROGRESS = 'UPDATE_FETCH_PATHOLOGIST_PENDING_DATA_INPROGRESS'
export const ADD_PATHOLOGIST_COMPLETED_DATA = 'ADD_PATHOLOGIST_COMPLETED_DATA'
export const UPDATE_FETCH_PATHOLOGIST_COMPLETE_DATA_INPROGRESS = 'UPDATE_FETCH_PATHOLOGIST_COMPLETE_DATA_INPROGRESS'
export const UPDATE_ITADMIN_FETCH_COMPLETE_STATE_INPROGRESS = 'UPDATE_ITADMIN_FETCH_COMPLETE_STATE_INPROGRESS'
export const CALENDAR_ERROR = 'CALENDAR_ERROR'
export const FILTER_PAYLOAD = 'FILTER_PAYLOAD'
export const CALENDAR_SUCCESS = 'CALENDAR_SUCCESS'
export const RECEIVE_SLIDES_DATA = 'RECEIVE_SLIDES_DATA'
export const SEND_SLIDES_DATA = 'SEND_SLIDES_DATA'
export const GET_USER_LIST_MINIMAL_DATA = 'GET_USER_LIST_MINIMAL_DATA'
export const ADD_USER_DROPDOWN = 'ADD_USER_DROPDOWN'
export const ADD_RECENTLY_RELEASED_DATA = 'ADD_RECENTLY_RELEASED_DATA'
export const UPDATE_FETCH_RECENTLY_RELEASED_INPROGRESS = 'UPDATE_FETCH_RECENTLY_RELEASED_INPROGRESS'
export const ADD_UNASSIGNED_DATA = 'ADD_UNASSIGNED_DATA'
export const UPDATE_FETCH_UNASSIGNED_DATA_INPROGRESS = 'UPDATE_FETCH_UNASSIGNED_DATA_INPROGRESS'
export const ADD_ASSIGNED_DATA = 'ADD_ASSIGNED_DATA'
export const UPDATE_FETCH_ASSIGNED_DATA_INPROGRESS = 'UPDATE_FETCH_ASSIGNED_DATA_INPROGRESS'
export const ADD_QC_CASES_DATA = 'ADD_QC_CASES_DATA'
export const UPDATE_FETCH_QC_DATA_INPROGRESS = 'UPDATE_FETCH_QC_DATA_INPROGRESS'
export const ADD_LM_COMPLETE_DATA = 'ADD_LM_COMPLETE_DATA'
export const UPDATE_FETCH_LM_COMPLETE_DATA_INPROGRESS = 'UPDATE_FETCH_LM_COMPLETE_DATA_INPROGRESS'
export const ADD_ITADMIN_UNASSIGNED_DATA = 'ADD_ITADMIN_UNASSIGNED_DATA'
export const UPDATE_ITADMIN_FETCH_UNASSIGNED_DATA_INPROGRESS = 'UPDATE_ITADMIN_FETCH_UNASSIGNED_DATA_INPROGRESS'
export const ADD_ITADMIN_ASSIGNED_DATA = 'ADD_ITADMIN_ASSIGNED_DATA'
export const UPDATE_ITADMIN_FETCH_ASSIGNED_DATA_INPROGRESS = 'UPDATE_ITADMIN_FETCH_ASSIGNED_DATA_INPROGRESS'
export const ADD_ITADMIN_QC_CASES_DATA = 'ADD_ITADMIN_QC_CASES_DATA'
export const UPDATE_ITADMIN_FETCH_QC_DATA_INPROGRESS = 'UPDATE_ITADMIN_FETCH_QC_DATA_INPROGRESS'
export const ADD_ITADMIN_COMPLETE_DATA = 'ADD_ITADMIN_LM_COMPLETE_DATA'
export const ADD_ITADMIN_SETTINGS_DATA = 'ADD_ITADMIN_SETTINGS_DATA'
export const ADD_ITADMIN_STATE_DATA = 'ADD_ITADMIN_STATE_DATA'
export const UPDATE_ADMIN_STATE_DATA = 'UPDATE_ITADMIN_STATE_DATA'
export const DELETE_ITADMIN_STATE_DATA = 'DELETE_ITADMIN_STATE_DATA'
export const UPDATE_ITADMIN_FETCH_COMPLETE_DATA_INPROGRESS = 'UPDATE_ITADMIN_FETCH_LM_COMPLETE_DATA_INPROGRESS'
export const INBOX_ERROR = 'INBOX_ERROR'
export const ADD_USER_SUCCESS = 'ADD_USER_SUCCESS'
export const ADD_USER_ERROR = 'ADD_USER_ERROR'
export const EDIT_USER_SUCCESS = 'EDIT_USER_SUCCESS'
export const EDIT_USER_ERROR = 'EDIT_USER_ERROR'
export const ADD_SEARCH_DATA = 'ADD_SEARCH_DATA'
export const UPDATE_SEARCH_DATA_INPROGRESS = 'UPDATE_SEARCH_DATA_INPROGRESS'
export const SEARCH_DATA_ERROR = 'SEARCH_DATA_ERROR'
export const SEARCH_DATA_SUCCESS = 'SEARCH_DATA_SUCCESS'
export const FILTER_PROCEDURE_CODE = 'FILTER_PROCEDURE_CODE'
export const ADD_REPORTING_INFO = 'ADD_REPORTING_INFO'
export const UPDATE_FETCH_REPORTING_DATA_INPROGRESS = 'UPDATE_FETCH_REPORTING_DATA_INPROGRESS'
export const ADD_LOADBALANCE_LOG_INFO = 'ADD_LOADBALANCE_LOG_INFO'
export const UPDATE_LOADBALANCE_LOG_INPROGRESS = 'UPDATE_LOADBALANCE_LOG_INPROGRESS'
export const UPDATE_LOGISTICS_RECEIVE_SLIDES_ERROR = 'UPDATE_LOGISTICS_RECEIVE_SLIDES_ERROR'
export const UPDATE_LOGISTICS_RECEIVE_SLIDES_SUCCESS = 'UPDATE_LOGISTICS_RECEIVE_SLIDES_SUCCESS'
export const UPDATE_LOGISTICS_RECEIVE_SLIDES_CLOSE = 'UPDATE_LOGISTICS_RECEIVE_SLIDES_CLOSE'
export const UPDATE_LOGISTICS_SEND_SLIDES_ERROR = 'UPDATE_LOGISTICS_SEND_SLIDES_ERROR'
export const UPDATE_LOGISTICS_SEND_SLIDES_SUCCESS = 'UPDATE_LOGISTICS_SEND_SLIDES_SUCCESS'
export const DELETE_SETTING_ERROR = 'DELETE_SETTING_ERROR'
export const DELETE_SETTING_SUCCESS = 'DELETE_SETTING_SUCCESS'
export const ADD_SETTING_ERROR = 'ADD_SETTING_ERROR'
export const ADD_SETTING_SUCCESS = 'ADD_SETTING_SUCCESS'
export const ADD_STATE_SUCCESS = 'ADD_STATE_SUCCESS'
export const ADD_STATE_ERROR = 'ADD_STATE_ERROR'
export const DELETE_STATE_SUCCESS = 'DELETE_STATE_SUCCESS'
export const DELETE_STATE_ERROR = 'DELETE_STATE_ERROR'
export const ADD_DUPLICATE_SETTING = 'ADD_DUPLICATE_SETTING'
export const EDIT_SETTING_ERROR = 'EDIT_SETTING_ERROR'
export const EDIT_SETTING_SUCCESS = 'EDIT_SETTING_SUCCESS'
export const EDIT_STATE_ERROR = 'EDIT_STATE_ERROR'
export const EDIT_STATE_SUCCESS = 'EDIT_STATE_SUCCESS'
export const ADD_LAB_TRANSFER_LIST = 'ADD_LAB_TRANSFER_LIST'
export const TRANSFER_CASE_SUCCESS = 'TRANSFER_CASE_SUCCESS'
export const TRANSFER_CASE_ERROR = 'TRANSFER_CASE_ERROR'
export const CORRECTION_CASE_SUCCESS = 'CORRECTION_CASE_SUCCESS'
export const CORRECTION_CASE_ERROR = 'CORRECTION_CASE_ERROR'
export const AMEND_CASE_INPROGRESS = 'AMEND_CASE_INPROGRESS'
export const AMEND_CASE_SUCCESS = 'AMEND_CASE_SUCCESS'
export const AMEND_CASE_ERROR = 'AMEND_CASE_ERROR'
export const UNASSIGN_CASE_SUCCESS = 'UNASSIGN_CASE_SUCCESS'
export const UNASSIGN_CASE_ERROR = 'UNASSIGN_CASE_ERROR'
export const EMPTY_TRANSFER_LIST = 'EMPTY_TRANSFER_LIST'
export const ADD_TRANSFER_LIST = 'ADD_TRANSFER_LIST'
export const ADD_HOLIDAY_ERROR = 'ADD_HOLIDAY_ERROR'
export const ADD_HOLIDAY_SUCCESS = 'ADD_HOLIDAY_SUCCESS'
export const EDIT_HOLIDAY_ERROR = 'EDIT_HOLIDAY_ERROR'
export const EDIT_HOLIDAY_SUCCESS = 'EDIT_HOLIDAY_SUCCESS'
export const DELETE_HOLIDAY_ERROR = 'DELETE_HOLIDAY_ERROR'
export const DELETE_HOLIDAY_SUCCESS = 'DELETE_HOLIDAY_SUCCESS'
export const ADD_QC_LOG_INFO = 'ADD_QC_LOG_INFO'
export const UPDATE_FETCH_QCLOGS_DATA_INPROGRESS = 'UPDATE_FETCH_QCLOGS_DATA_INPROGRESS'
export const ADD_REPORT_UPLOAD_LOG_INFO = 'ADD_REPORT_UPLOAD_LOG_INFO'
export const UPDATE_FETCH_REPORT_UPLOAD_DATA_INPROGRESS = 'UPDATE_FETCH_REPORT_UPLOAD_DATA_INPROGRESS'
export const SET_REPORT_DIAGNOSIS_DATA = 'SET_REPORT_DIAGNOSIS_DATA'
export const SET_CATEGORIZED_DATA = 'SET_CATEGORIZED_DATA'
export const SET_REPORT_COMMENTS_DATA = 'SET_REPORT_COMMENTS_DATA'
export const SET_REPORT_COMMENT_OBJECTS_DATA = 'SET_REPORT_COMMENT_OBJECTS_DATA'
export const SET_TRF_INFO = 'SET_TRF_INFO'
export const SET_SLIDE_DIAGNOSIS_OPTIONS = 'SET_SLIDE_DIAGNOSIS_OPTIONS'
export const SET_IMAGE_QUALITY_OPTIONS = 'SET_IMAGE_QUALITY_OPTIONS'
export const GET_CASE_DATA = 'GET_CASE_DATA'
export const SELECT_IMAGE_FOR_REPORT = 'SELECT_IMAGE_FOR_REPORT'
export const SET_SHOWING_RECT = 'SET_SHOWING_RECT'
export const ADD_SAMPLE_LOCATION_DATA = 'ADD_SAMPLE_LOCATION_DATA'
export const ADD_SUMMARY_TREE_DATA = 'ADD_SUMMARY_TREE_DATA'
export const ADD_BARCODE_DATA = 'ADD_BARCODE_DATA'
export const SET_ALL_SLIDES = 'SET_ALL_SLIDES'
export const ADD_CLINICAL_INFO = 'ADD_CLINICAL_INFO'
export const SAVE_SLIDE_DIAGNOSIS_SUCCESS = 'SAVE_SLIDE_DIAGNOSIS_SUCCESS'
export const SAVE_SLIDE_DIAGNOSIS_ERROR = 'SAVE_SLIDE_DIAGNOSIS_ERROR'
export const GET_SLIDE_DIAGNOSIS = 'GET_SLIDE_DIAGNOSIS'
export const GET_REPORT_HISTORY = 'GET_REPORT_HISTORY'
export const SET_REPORT_DATA = 'SET_REPORT_DATA'
export const SET_PATIENT_HISTORY = 'SET_PATIENT_HISTORY'
export const UPDATE_PATIENTHISTORY_FETCH_INPROGRESS = 'UPDATE_PATIENTHISTORY_FETCH_INPROGRESS'
export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE'
export const SAVE_REPORT_DRAFT_SUCCESS = 'SAVE_REPORT_DRAFT_SUCCESS'
export const SAVE_REPORT_DRAFT_ERROR = 'SAVE_REPORT_DRAFT_ERROR'
export const SET_DRAFT_REPORT = 'SET_DRAFT_REPORT'
export const SESSION_STATUS = 'SESSION_STATUS'
export const SESSION_SUCCESS = 'SESSION_SUCCESS'
export const SESSION_ERROR = 'SESSION_ERROR'
export const TOKEN_ACTIVATE_STATUS = 'TOKEN_ACTIVATE_STATUS'
export const GET_CPT_CODES = 'GET_CPT_CODES'
export const SAVE_REPORT_DATA = 'SAVE_REPORT_DATA'
export const GET_PDF_BYTES = 'GET_PDF_BYTES'
export const GET_PREMERIS_REGIONS = 'GET_PREMERIS_REGIONS'
export const CONSULT_CASE_SUCCESS = 'CONSULT_CASE_SUCCESS'
export const CONSULT_CASE_ERROR = 'CONSULT_CASE_ERROR'
export const ADD_PATHOLOGISTS_LIST = 'ADD_PATHOLOGISTS_LIST'
export const EMPTY_PATHOLOGISTS_LIST = 'EMPTY_PATHOLOGISTS_LIST'
export const CONSULT_COMPLETE_SUCCESS = 'CONSULT_COMPLETE_SUCCESS'
export const CONSULT_COMPLETE_ERROR = 'CONSULT_COMPLETE_ERROR'
export const ADD_PATHOLOGIST_NAMES_LIST = 'ADD_PATHOLOGIST_NAMES_LIST'
export const SAVE_REPORT_SUCCESS = 'SAVE_REPORT_SUCCESS'
export const SAVE_REPORT_ERROR = 'SAVE_REPORT_ERROR'
export const SAVE_REPORT_RESET = 'SAVE_REPORT_RESET'
export const AMEND_REPORT_SUCCESS = 'AMEND_REPORT_SUCCESS'
export const AMEND_REPORT_ERROR = 'AMEND_REPORT_ERROR'
export const UPLOAD_REPORT_SUCCESS = 'UPLOAD_REPORT_SUCCESS'
export const UPLOAD_REPORT_ERROR = 'UPLOAD_REPORT_ERROR'
export const UPLOAD_REPORT_RESET = 'UPLOAD_REPORT_RESET'
export const SET_REPORT_URL = 'SET_REPORT_URL'
export const SET_CASE_DIAGNOSIS = 'SET_CASE_DIAGNOSIS'
export const SET_SIGNED_URL_TO_SAVE_REPORT = 'SET_SIGNED_URL_TO_SAVE_REPORT'
export const SET_TRF_URL = 'SET_TRF_URL'
export const SET_UPLOAD_URL = 'SET_UPLOAD_URL'
export const GET_SAVE_STATE = 'GET_SAVE_STATE'
export const REFRESH_CASE = 'REFRESH_CASE'
export const REFRESH_CASE_ERROR = 'REFRESH_CASE_ERROR'
export const REFRESH_CASE_SUCCESS = 'REFRESH_CASE_SUCCESS'
export const UPDATE_REFRESH_INPROGRESS = 'UPDATE_REFRESH_INPROGRESS'
export const SET_FOLLOW_UP_DATA = 'SET_FOLLOW_UP_DATA'
export const SET_MICROSCOPIC_DESCRIPTION_DATA = 'SET_MICROSCOPIC_DESCRIPTION_DATA'
export const UPDATE_FREEZE_STATUS_SUCCESS = 'UPDATE_FREEZE_STATUS_SUCCESS'
export const UPDATE_FREEZE_STATUS_ERROR = 'UPDATE_FREEZE_STATUS_ERROR'
export const AUDIT_CLASSIFIER = 'AUDIT_CLASSIFIER'
